





















import Vue, { PropType } from 'vue';
import { PeerGroupSort, PeerGroupSortField } from '@/preferences';
import { nextPeerGroupSort } from '@/peerGroupSort';

// Kept in greys so the control stays secondary to the list it orders.
const ACTIVE_PILL_CLASSES = [
  'grey',
  'lighten-3',
  'grey--text',
  'text--darken-3'
];
const INACTIVE_PILL_CLASSES = ['grey--text'];

export default Vue.extend({
  props: {
    sort: Object as PropType<PeerGroupSort>,
    disabled: Boolean
  },

  computed: {
    sortOptions(): {
      field: PeerGroupSortField;
      label: string;
      active: boolean;
      classes: string[];
    }[] {
      const options: { field: PeerGroupSortField; label: string }[] = [
        { field: 'name', label: 'Name' },
        { field: 'createdAt', label: 'Created' }
      ];

      return options.map(option => {
        const active = this.sort.field === option.field;

        return {
          ...option,
          active,
          classes: active ? ACTIVE_PILL_CLASSES : INACTIVE_PILL_CLASSES
        };
      });
    },
    // Up is A-Z / oldest first; down is the reverse.
    directionIcon(): string {
      return this.sort.descending ? 'mdi-arrow-down' : 'mdi-arrow-up';
    }
  },

  methods: {
    select(field: PeerGroupSortField) {
      this.$emit('change', nextPeerGroupSort(this.sort, field));
    }
  }
});
